@if (approversvc.loading()) {
  <p-progress-bar mode="indeterminate" [style]="{ height: '4px' }"></p-progress-bar>
} @else {
  <div class="form-row flex-align-center">
    <label>
      {{ Yii.t('app', 'Predefined Approvers') }}
    </label>
    <div>
      <ng-select
        [items]="approvers"
        [multiple]="true"
        bindLabel="full_name"
        [hideSelected]="true"
        appendTo="body"
        [(ngModel)]="assigned"
        (change)="sync()"
        placeholder="{{Yii.t('be_forms', 'Select Approver...')}}">
      </ng-select>
    </div>
  </div>
}
